<template>
  <div id="menu-page" class="page" refs="menu">
    <!-- TODO: To be removed after the sub menu task so I can use this to for testing and comparison -->
    <!-- <menuItemsComp></menuItemsComp> -->
    <div class="menu-heading">
      <p class="menu-title">{{productName}}</p>
      <p class="menu-caption">{{$t('label.loginString3')}}</p>
    </div>
  </div>
</template>

<script src="./menu.js"></script>
<style lang="scss" src="./menu.scss"></style>
